'use strict';

var processInclude = require('./base/util');

$(document).ready(function () {
    processInclude(require('./components/favoriteStore'));
    processInclude(require('./storeDetail/storeDetail'));
});
